declare global {
  interface Window {
    google?: {
      accounts?: {
        id?: {
          initialize: (options: {
            client_id: string
            callback: (response: { credential?: string }) => void
          }) => void
          renderButton: (
            element: HTMLElement,
            options: Record<string, string | number>
          ) => void
        }
      }
    }
  }
}

let googleScriptPromise: Promise<void> | null = null

function getGoogleClientId(): string {
  const clientId = document
    .querySelector('meta[name="google-client-id"]')
    ?.getAttribute('content')
    ?.trim()

  if (!clientId) {
    throw new Error('Falta configurar VITE_GOOGLE_CLIENT_ID')
  }

  return clientId
}

function loadGoogleScript(): Promise<void> {
  if (window.google?.accounts?.id) {
    return Promise.resolve()
  }

  if (googleScriptPromise) {
    return googleScriptPromise
  }

  googleScriptPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.src = 'https://accounts.google.com/gsi/client'
    script.async = true
    script.defer = true
    script.onload = () => resolve()
    script.onerror = () => reject(new Error('No se pudo cargar Google Identity Services'))
    document.head.appendChild(script)
  })

  return googleScriptPromise
}

export async function renderGoogleButton(
  element: HTMLElement,
  onCredential: (credential: string) => void
): Promise<void> {
  const clientId = getGoogleClientId()
  await loadGoogleScript()

  const googleId = window.google?.accounts?.id
  if (!googleId) {
    throw new Error('Google Identity Services no esta disponible')
  }

  googleId.initialize({
    client_id: clientId,
    callback: ({ credential }) => {
      if (credential) {
        onCredential(credential)
      }
    }
  })

  element.innerHTML = ''
  googleId.renderButton(element, {
    type: 'standard',
    theme: 'outline',
    size: 'large',
    text: 'continue_with',
    shape: 'pill',
    width: Math.max(element.clientWidth || 320, 280)
  })
}
